import { render, staticRenderFns } from "./NotesListSelection.vue?vue&type=template&id=40c9dde8&scoped=true"
import script from "./NotesListSelection.vue?vue&type=script&lang=js"
export * from "./NotesListSelection.vue?vue&type=script&lang=js"
import style0 from "./NotesListSelection.vue?vue&type=style&index=0&id=40c9dde8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9dde8",
  null
  
)

export default component.exports